import React from 'react';
import { Link } from 'react-router-dom';
import useMain from '../../hooks/useMain';
import Image from '../common/image';
import Shadow from './shadow';

function Risk() {
	const { theme } = useMain();

	return (
		<>
			<div className='container mb-5'>
				<div className='row align-items-center'>
					<div className='col-md-6 py-5'>
						<h1 className={`fw-bold text-set3-${theme}`}>Risk Management</h1>
						<p>
							MMP WORLD is a licensed financial platform committed to full compliance
							with blockchain industry regulations. To safeguard user investments, we
							implement robust risk management strategies. Risk management is a
							crucial element of financial planning, involving the identification,
							analysis, and mitigation of potential risks. Our strategies include
							investment diversification, thorough due diligence, and ongoing
							portfolio monitoring. By proactively managing risk, MMP WORLD aims to
							protect investor assets and ensure the long-term growth and stability of
							our offerings.
						</p>

						<Link
							to='/risks'
							className={`btn btn-set3-${theme} me-3`}>
							Learn More
						</Link>
					</div>

					<div className='col-md-6'>
						<Image
							className='w-100'
							fileName='home/risks.jpg'
						/>
					</div>
				</div>
			</div>
			<Shadow />
		</>
	);
}

export default Risk;
